module Dashboard {
    export class NotificationsWidgetConfig implements INotificationWidget {
        public id: string;
        public enabledByDefault: boolean;
        public displayName: string;
        public directiveName: string;
        public gridItemConfig: IGridItemConfig;
        public clearedNotifications: IClearedNotifications[];
        public rangeInDays: number;
        public environments: string[];

        constructor(id: string) {
            this.id = id;
            this.rangeInDays = 7;
            this.enabledByDefault = true;
            this.displayName = FRENDS.Localizations.NotificationsLabel;
            this.directiveName = "frends-notifications-widget";
            this.gridItemConfig = { col: 0, row: 2, sizeX: 6, sizeY: 4, disableResizing: false };
            this.clearedNotifications = [];
            this.environments = [];
        }
    }

    export interface INotificationWidget extends IWidgetConfig {
        clearedNotifications: IClearedNotifications[];
    }

    export interface IClearedNotifications {
        source: string;
        utcTimeStamp: string;
        id: string;
    }
}